module.exports = __webpack_public_path__ + "static/media/close.19314b5f.svg";